import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EstateJobMappingListing } from './Pages';

export const EstateJobMapping = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EstateJobMappingListing} />
    </Fragment>
)